module.exports = __webpack_public_path__ + "img/posImg.213cfd3f.png";